<div class="lds-roller" [ngClass]="{'lds-roller-ftd-blue': colorFtd}">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>